// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"6f5a4645","408":"665b70d4","729":"7ccaf570","787":"df7b7e15"}[chunkId] + ".chunk.js";
};